module.exports = __webpack_public_path__ + "static/media/join_1_over.237553fa.png";